import FormControl from "@mui/material/FormControl";
import type { FormControlProps } from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import type { SelectProps } from "@mui/material/Select";
import { styled } from "@mui/material/styles";

// Custom prop type for StyledFormControl
interface StyledFormControlProps extends FormControlProps {
  isMobile?: boolean;
}

export const StyledFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<StyledFormControlProps>(({ theme, isMobile }) => ({
  margin: theme.spacing(1),
  minWidth: 140,
  width: isMobile ? "100%" : "auto",
}));

export const StyledSelect = styled(Select)<SelectProps>(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: "4px",
  "&:focus": {
    backgroundColor: theme.palette.white.main,
  },
}));
